import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";
import { useApp } from "../../contexts/AppContext";

function usePages() {
  const basePath = useMemo(() => {
    return `/page`;
  }, []);

  const { organizationId } = useApp();

  return {
    getPages: () => apiInstance.post(organizationId + basePath + "/get-pages"),
    createPage: (payload) =>
      apiInstance.post(organizationId + basePath, payload),
    updatePage: (variables) => {
      const { pageId, payload } = variables;

      return apiInstance.put(`${organizationId + basePath}/${pageId}`, payload);
    },
    deletePage: (pageId) =>
      apiInstance.delete(`${organizationId + basePath}/${pageId}`),
    updateAccess: (payload) =>
      apiInstance.post(organizationId + basePath + "/update-access", payload),
  };
}

export default usePages;
